import React from "react";

export const SkeletonRows = ({ count = 4, className = "" }) => (
  <div
    className={`space-y-3 animate-pulse ${className}`}
    role="status"
    aria-label="Loading"
  >
    {Array.from({ length: count }).map((_, index) => (
      <div
        key={index}
        className={`h-4 bg-brand-charcoal/10 rounded ${
          index % 3 === 2 ? "w-2/3" : "w-full"
        }`}
      />
    ))}
  </div>
);

const SkeletonBoard = ({ rows = 4, className = "", header = true }) => (
  <div
    className={`card-board overflow-hidden ${className}`}
    role="status"
    aria-label="Loading"
  >
    {header ? (
      <div className="bg-brand-charcoal px-6 py-4 animate-pulse">
        <div className="h-6 bg-brand-mist/40 rounded-lg w-32 mb-2" />
        <div className="h-4 bg-brand-mist/30 rounded-lg w-48" />
      </div>
    ) : null}
    <div className="p-6">
      <SkeletonRows count={rows} />
    </div>
  </div>
);

export default SkeletonBoard;
